import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';
import { MainSpecialityService } from 'src/app/sas/services/main-speciality.service';
import { DoctorsService } from 'src/app/sas/services/doctors.service';
import { NewsService } from 'src/app/sas/services/news.service';
import { MainSpeciality } from '../../shared/models/DTO/MainSpeciality';
import { Doctor } from 'src/app/shared/models/DTO/Doctor';
import { News } from 'src/app/shared/models/DTO/News';
import { environment } from 'src/environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})

export class DefaultComponent implements OnInit {


  mainSpecialities : MainSpeciality [] = [];
  doctors : Doctor [] = [];
  news : News [] = [];
  specialNews : News  = new News();

  constructor(public _MainSpecialityService : MainSpecialityService , public _DoctorService: DoctorsService, public _NewsService: NewsService,
              private router: Router,public global: Globals,translate: TranslateService,config: NgbCarouselConfig) {
    translate.setDefaultLang('AR');

    // customize default values of carousels used by this component tree
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;
    config.interval = 10000;
    // config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

  }

  ngOnInit() {
    this.getMainSpecialities();
    this.GetDoctorsDisplayedAtMainPage();
    this.GetSpecialNews();
    this.GetNewsDisplayedAtMainPage();
  }

  moreClicked(){
    this.router.navigateByUrl("/Sas/TreatmentPlatform");
  }
  goToConsultant(){
    this.router.navigateByUrl("/Sas/ConsultantPlatform");
  }

  getMainSpecialities(){
    this._MainSpecialityService.GetMainSpecialities().subscribe(
      (data:any) => {
        console.log("mainSpecialities :",data.data);
        if(data.status !=-1){
          this.mainSpecialities = data.data;
        }
        else{
          console.log('لم يتم العثور على التخصصات الرئيسية.');
        }
        this.global.spinner = false;
      },
      (error:any) =>{
        console.log(error);
        this.global.spinner = false;
      });
  }

  GetDoctorsDisplayedAtMainPage(){
    this._DoctorService.GetDoctorsDisplayedAtMainPage().subscribe(
      (data:any) => {
        console.log("doctors :",data.data);
        if(data.status !=-1){
          this.doctors = data.data;
        }
        else{
          console.log('لم يتم العثور على الأخصائيين.');
        }
        this.global.spinner = false;
      },
      (error:any) =>{
        console.log(error);
        this.global.spinner = false;
      });
  }

  GetNewsDisplayedAtMainPage(){
    this._NewsService.GetNewsDisplayedAtMainPage().subscribe(
      (data:any) => {
        console.log("news :",data.data);
        if(data.status !=-1){
          this.news = data.data;
        }
        else{
          console.log('لم يتم العثور على الأخبار.');
        }
        this.global.spinner = false;
      },
      (error:any) =>{
        console.log(error);
        this.global.spinner = false;
      });
  }

  GetSpecialNews(){
    this._NewsService.GetSpecialNews().subscribe(
      (data:any) => {
        console.log("specialNews :",data.data);
        if(data.status !=-1){
          this.specialNews = data.data;
        }
        else{
          console.log('لم يتم العثور على الأخبار المميزة.');
        }
        this.global.spinner = false;
      },
      (error:any) =>{
        console.log(error);
        this.global.spinner = false;
      });
  }

  DisplayedDoctorImage(pictureUrl){
    if (pictureUrl){
      return `${environment.API_URL}/../${pictureUrl}`;
    }
    else{
      return '../../../assets/images/doctor.png';
    }
  }

  DisplayedNewsImage(pictureUrl){
    if (pictureUrl){
      return `${environment.API_URL}/../${pictureUrl}`;
    }
    else{
      return '../../../assets/images/newspaper.jpg';
    }
  }

  removeFixedNews(){
    $("#fixedBottomNews").slideUp(500);
  }

   customOptions: OwlOptions = {
      loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    nav: false,
    rtl: true,
    autoplay: true,
    autoplayTimeout: 5000,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  }
  newsOptions: OwlOptions = {
     loop: true,
    items: 1,
    rtl: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: true,
    navSpeed: 700,
    margin: 20,
    //center:true,
    //stagePadding:40,
    dotsEach: true,

    responsive: {
      640: {
        items: 1.5,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
    nav: true,
    navText: [
      '<img src="assets/images/angle-right-white.svg" alt="arrow" title="arrow" loading="lazy" decoding="async"/>',
      '<img src="assets/images/angle-left-white.svg" alt="arrow" title="arrow" loading="lazy" decoding="async"/>',
    ],
  }
   docOptions: OwlOptions = {
     loop: true,
    items: 1,
    rtl: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: true,
    navSpeed: 2000,
    margin: 20,
    //center:true,
    //stagePadding:40,
    dotsEach: true,

    responsive: {
      640: {
        items: 1.5,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
    nav: true,
    navText: [
      '<img src="assets/images/angle-right-white.svg" alt="arrow" title="arrow" loading="lazy" decoding="async"/>',
      '<img src="assets/images/angle-left-white.svg" alt="arrow" title="arrow" loading="lazy" decoding="async"/>',
    ],
  }
}
